import React, { useState } from 'react';

import CardDialog from '~/components/CardDialog';
import { SortableTable } from '~/components/core';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import ContactFinanceVerificationActionCell from '~/components/Finances/FinanceApprovalsTab/ContactFinanceVerificationApprovals/ContactFinanceVerificationActionCell';
import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';
import useDataFetcher from '~/components/useDataFetcher';
import { serverDateTimeToLocal } from '~/DateTimeUtils';
import type {
  PendingVerificationsListResponse,
  PendingVerificationsListResponsePendingVerificationItem,
} from '~/server_shared/openapi/data-contracts';

const RESULTS_PER_PAGE = 10;

const ContactFinanceVerificationApprovals: React.FC = () => {
  const [page, setPage] = useState(0);

  const { isLoading, isError, data, reloadData } = useDataFetcher<PendingVerificationsListResponse>(
    `/api/v1/contact_finance_verification/pending?page_number=${page + 1}&results_per_page=${RESULTS_PER_PAGE}`,
    {}
  );

  const columns = [
    {
      id: 'contact_name',
      label: 'Contact Name',
      disableSort: true,
      specialCell: (row: PendingVerificationsListResponsePendingVerificationItem) => (
        <OverflowTextWithToolTip maxWidth="200px">{row.contact_name}</OverflowTextWithToolTip>
      ),
    },
    {
      id: 'requesting_user',
      label: 'Requested By',
      disableSort: true,
      specialCell: (row: PendingVerificationsListResponsePendingVerificationItem) => row.requesting_user,
    },
    {
      id: 'request_datetime',
      label: 'Request Date',
      disableSort: true,
      specialCell: (row: PendingVerificationsListResponsePendingVerificationItem) =>
        row.request_datetime && serverDateTimeToLocal(row.request_datetime),
    },
    {
      id: 'actions',
      label: 'Actions',
      disableSort: true,
      align: 'right',
      specialCell: (row: PendingVerificationsListResponsePendingVerificationItem) => (
        <ContactFinanceVerificationActionCell row={row} onReload={reloadData} />
      ),
    },
  ];

  const verifications = data?.verifications ?? [];
  const totalCount = data?.count ?? 0;

  return (
    <CardDialog noCardTitle>
      <div className="p-20">
        <div>
          {isLoading || isError ? (
            <SkeletonTable columnsCount={columns.length} rowsCount={RESULTS_PER_PAGE} isError={isError} />
          ) : (
            <SortableTable
              rows={verifications}
              columns={columns}
              paginationProps={{
                page,
                rowsPerPage: RESULTS_PER_PAGE,
                onChangePage: (_: unknown, newPage: number) => {
                  setPage(newPage);
                },
                disabled: isLoading,
                count: totalCount,
                rowsPerPageOptions: [RESULTS_PER_PAGE],
              }}
            />
          )}
        </div>
      </div>
    </CardDialog>
  );
};

export default ContactFinanceVerificationApprovals;
